<template>
  <v-app id="inspire" style="background: #eeeeee">
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: 'App',
}
</script>
